import { search } from "../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/financeiro/bandeiras/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);

headers.append("content-type", "application/json");

export async function findBandeiras(empresa_cnpj, where = {}) {
  let queryWhere = "";
  Object.keys(where).forEach((key) => {
    queryWhere += `&where[${key}]=${where[key]}`;
  });

  return search(
    `${path}?empresa_cnpj=${empresa_cnpj}${queryWhere}`,
    "GET",
    headers
  );
}
